import React, { useContext, useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import GridViewIcon from '@mui/icons-material/GridView';
import { IconButton, LinearProgress, Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid2';
import logo from '../assets/nplogo.jpg';
import axios from 'axios';
import LogoutIcon from '@mui/icons-material/Logout';
import {
  fetchData,
  getDataFromApi1,
  getDataFromApi2,
  getDataFromApi3,
  getDataFromApi4,
  getDataFromApi5,
} from '../api/index';
import SignInPage from './SingIn';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
export default function Homepage() {
  const [loading, setLoading] = useState(false);
  const [data1, setData1] = useState(null);
  const [data2, setData2] = useState(null);
  const [data3, setData3] = useState(null);
  const [data4, setData4] = useState(null);
  // Different tokens for each API request (null means no token)
  const tokens = [
    process.env.REACT_APP_API_TOKEN_1,
    null,
    null,
    null,
    process.env.REACT_APP_API_TOKEN_5,
    process.env.REACT_APP_API_TOKEN_6,
    process.env.REACT_APP_API_TOKEN_7,
    process.env.REACT_APP_API_TOKEN_8,
    process.env.REACT_APP_API_TOKEN_9,
  ];

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);

      try {
        // Fetch data from API
        const [
          d1,
          d2,
          d3,
          d4,
        ] = await fetchData(tokens);

        // Store data in separate state variables
        setData1(d1);
        setData2(d2);
        setData3(d3);
        setData4(d4);
        
        console.log('data', d1);
        console.log('data', d2);
        console.log('data', d3);
        console.log('data', d4);
      } catch (error) {
        console.error('Failed to fetch data');
      } finally {
        setLoading(false);
      }
    };

    // Initial fetch
    loadData();

    // Set interval to refresh every 5 seconds
    const interval = setInterval(loadData, 5000);

    // Cleanup interval when component unmounts
    return () => clearInterval(interval);
  }, []); // Re-run if tokens change
  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  useEffect(() => {
    const loginTimestamp = localStorage.getItem('loginTimestamp');

    if (loginTimestamp) {
      const currentTime = new Date().getTime();
      const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;

      if (currentTime - loginTimestamp > sevenDaysInMs) {
        handleLogout(); // Expired, auto-logout
      }
    }
  }, []);
  const handleLogout = () => {
    dispatch({ type: 'LOGOUT' });
    localStorage.removeItem('loginTimestamp');

    navigate('/');
  };
  console.log('data', data1);
  console.log('data', data2);
  console.log('data', data3);
  console.log('data', data4);
  return (
    <div className="home-container">
      <div className="loding-container">{loading && <LinearProgress />}</div>
      <div className="nav-container">
        <div className="nav-right">
          <img src={logo} alt="" />
          <h1>Pub Tracker Agent Status </h1>
        </div>
      </div>
      <div className="main-container">
        <div className="right-container">
          <Grid container spacing={3}>
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">Blade</div>
                <div className="card-title">
                  <span>Blade:</span>{' '}
                  <span
                    className={
                      data1?.ready && parseInt(data1?.ready) > 0
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {data1?.ready || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">Mammo FE CPL</div>
                <div className="card-title">
                  <span>Mammo FE CPL:</span>{' '}
                  <span
                    className={
                      data2?.ready && parseInt(data2?.ready)
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {data2?.ready || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">BP ACA IB High</div>
                <div className="card-title">
                  <span>BP ACA IB High:</span>{' '}
                  <span
                    className={
                      data3?.ready && parseInt(data3?.ready)
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {data3?.ready || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">ADV ACA IB</div>
                <div className="card-title">
                  <span>ADV ACA IB:</span>{' '}
                  <span
                    className={
                      data4?.ready && parseInt(data4?.ready)
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {data4?.ready || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid>{' '}
          </Grid>
        </div>
      </div>
    </div>
  );
}
